import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function RestockPlanItemForm() {
  return (
    <ArrayInput
      source="restock_plan_items"
      defaultValue={[
        {
          // kalo tdk terlist disini input field
          // di form lain sama2 terupdate
          // saat salah satunya di rubah
          ten_code: "",
          average_sales: "", // disabled
          stock: "", // disabled
          buffer_minimal: "", // disabled
          buffer_maximal: "", // disabled
          restock_minimal: "", // disabled
          restock_maximal: "", // disabled
          goods_in_transit: "", // disabled barang dalam perjalanan
          final: "",
          note: "",
          day_range: "",
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{(props) => Inputs({ ...props })}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
